import { Component, OnInit, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'swb-page-tiles',
  templateUrl: './page-tiles.component.html'
})
export class PageTilesComponent implements OnInit {

  public query: string;

  @Output() filterEvent = new EventEmitter<string>();

  constructor() { }

  ngOnInit() {
  }

  public filter(query: string): void {
    this.query = query;
  }
}
